<template>
  <div class="form-passport">
    <div class="form-passport__row serial">
      <input-text
        type="text"
        placeholder="Серия"
        title="Серия"
        input-mode="numeric"
        v-bind:violations="serialInputError"
        v-mask="'## ##'"
        v-model="identification.serial" />
      <input-text
        type="text"
        placeholder="Номер"
        title="Номер"
        input-mode="numeric"
        v-bind:violations="numberInputError"
        v-mask="'######'"
        v-model="identification.number" />
      <input-date
        class="form-passport-date"
        label="Когда выдан"
        v-bind:violations="whenIssuedInputError"
        v-model="identification.whenIssued" />
      <input-text
        type="text"
        placeholder="Код подразделения"
        title="Код подразделения"
        input-mode="numeric"
        v-bind:violations="departmentCodeInputError"
        v-mask="'###-###'"
        v-model="identification.departmentCode" />
    </div>
    <textarea-length-limitation
      class="form-passport__belay"
      v-model="identification.whoIssued"
      placeholder="Кем выдан"
      title="Кем выдан"
      rows="3"
      v-bind:max-length="200"
      v-bind:violations="whoIssuedInputError" />
    <slot name="bottom" />
  </div>
</template>

<script>
import { Identification } from '@/storage/gateways/PatientGateway';
import InputText from '@/components/InputText.vue';
import TextareaLengthLimitation from '@/components/TextareaLengthLimitation.vue';
import InputDate from '@/components/InputDate.vue';

/**
 * События обновления модели
 * @type {string}
 */
const ON_MODEL_UPDATE = 'on-model-update';

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.inputErrors ? vm.inputErrors[cause] : []
);
export default {
  components: {
    InputDate,
    InputText,
    TextareaLengthLimitation,
  },
  computed: {
    addressInputError: resolveInputErrors('identification.address'),
    livingAddressInputError: resolveInputErrors('identification.livingAddress'),
    numberInputError: resolveInputErrors('identification.number'),
    serialInputError: resolveInputErrors('identification.serial'),
    whenIssuedInputError: resolveInputErrors('identification.when_issued'),
    whoIssuedInputError: resolveInputErrors('identification.who_issued'),
    departmentCodeInputError: resolveInputErrors('identification.department_code'),
  },
  name: 'FormPassport',
  props: {
    initIdentification: { required: true, type: Identification },
    inputErrors: { required: true, type: Object },
  },
  watch: {
    /**
     * @description Данные обновились
     *
     * @param newValue
     * @param oldValue
     */
    identification: {
      handler(newValue) {
        this.$emit(ON_MODEL_UPDATE, newValue);
        this.identification = newValue;
      },
      deep: true,
    },
  },
  created() {
    this.identification = this.initIdentification;
  },
  data() {
    return {
      identification: {},
    };
  },
};
</script>

<style scoped lang="scss">
.form-passport {
  display: grid;
  row-gap: 20px;
  &__row {
    display: grid;
    grid-template-columns: 333px 236px;
    grid-gap: 11px;
    &.serial {
      grid-template-columns: 150px 150px 1fr 1fr;
      max-width: 100%;
    }
  }
  &__copy {
    margin-top: 15px;
    &__button {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 12px;
      margin: 0 0 2px 0;
      color: var(--unfocus-color);
      &:after {
        content: '';
        background-image: url("@/assets/img/copy-blue.svg");
        background-repeat: no-repeat;
        background-position: bottom;
        background-size: contain;
        margin: 0 0 0 10px;
        width: 15px;
        height: 15px;
      }
    }
  }
  &__invalid {
    color: var(--warning-color);
    font-size: 12px;
    font-weight: 400;
    padding: 0.125rem;
    margin-bottom: 0;
  }
  &__snils {
    width: 333px;
  }
  &__belay {
    width: 100%;
    &.indent {
      margin-bottom: -20px;
    }
  }
}
@media screen and (max-width: 970px) {
  .form-passport {
    &__belay,
    &__snils,
    &__date {
      width: 100%;
    }
    &__row {
      grid-template-columns: 1fr;
      grid-gap: 20px;
      &.serial {
        grid-template-columns: 1fr;
      }
    }
    &__representative {
      &__row {
        grid-template-columns: 1fr;
      }
    }
  }
}
@media screen and (max-width: 480px) {
  .form-passport {
    &__medical {
      &-card {
        padding: 20px 15px;
        &__info {
          flex-direction: column;
          align-items: flex-start;
        }
        &__buttons {
          width: 230px;
          flex-direction: column;
        }
        &__button {
          &-print {
            display: none;
          }
          &-save {
            max-width: 100%;
          }
        }
      }
    }
    &__representative {
      &__row {
        &.document {
          grid-template-columns: 1fr;
        }
      }
    }
  }
}
</style>
